// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav-item .btn-actions{display:none}.nav-item:hover .btn-actions{display:block}", ""]);
// Exports
module.exports = exports;
